export default "__VITE_ASSET__TPyy00PF__"